import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from '../store';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: store.state.darkTheme,
    themes: {
      light: {
        primary: '#86BC25',
        success: '#86BC25',
      },
      dark: {
        primary: '#86BC25',
        success: '#86BC25',
        darken4: '#FF0000'
      }
    }
  }
});